import React, { useCallback, useRef, useState } from 'react';
import Icon from 'components/icon/icon'
import EmojiPopover from 'components/emoji-popover/emoji-popover'

import { isMobile } from 'utils'

const ControlsLikeContainer = props => {
    const {
        likersIds,
        likeCallback,
        allUsers,
        thisUser,
        isEditing,
        isArchived,
        canEdit,
        canReply,
        replyCallback,
        editCallback,
        deleteCallback,
        saveCallback,
        cancelCallback,
        metaText,
        likersAsTooltip,
        reactCallback
    } = props

    const likersIdsLength = likersIds ? likersIds.length : 0

    const reactTriggerRef = useRef(null)
    // null (not rendered) | 'open' | 'closing' (fading out, still rendered)
    const [emojiPopoverState, setEmojiPopoverState] = useState(null)
    const isEmojiPopoverOpen = emojiPopoverState === 'open'

    const closeEmojiPopover = useCallback(() => setEmojiPopoverState(state => state && 'closing'), [])
    const removeEmojiPopover = useCallback(() => setEmojiPopoverState(null), [])

    const likeContainerRef = useCallback(node => {
        if (!node) return
        const tooltip = node.querySelector('.tooltip')
        if (!tooltip) return
        const rect = node.getBoundingClientRect()
        const isRightHalf = rect.left + rect.width / 2 >= window.innerWidth / 2
        tooltip.classList.toggle('top-right', isRightHalf)
    }, [])

    let hasLikers = false
    let currentUserLikesComment = false
    let likerList = []

    let likerListString = ''

    if (likersIds && likersIds.length) {
        hasLikers = true

        likersIds.forEach(likerId => {
            if (likerId === thisUser.id) {
                currentUserLikesComment = true;
            }

            const user = allUsers[likerId]

            if(user){
                likerList.push(allUsers[likerId])
            }
        })

        likerList.sort((a, b) => {
            var textA = a.first_name.toUpperCase()
            var textB = b.first_name.toUpperCase()

            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        })

        likerList.forEach((liker, index) => {
            if (index !== 0) {
                if (index == (likerList.length - 1)) {
                    likerListString += ' & ';
                } else {
                    likerListString += ', ';
                }
            }

            likerListString += liker.first_name

            if(!likersAsTooltip){
                likerListString += ' '+liker.last_name
            }
        })
    }

    return (
        <div
            className={`controls-container${hasLikers ? ' has-likers' : ''}`}
            onClick={e => e.stopPropagation()}
        >
            {!isEditing ?
                <div>
                    { metaText ? 
                        <span className={`meta ${ hasLikers ? 'sticky' : ''}`}>
                            { metaText }
                        </span>
                    : null }
                    { (hasLikers || (!isArchived && likeCallback)) ?
                        <span
                            ref={(hasLikers && likersAsTooltip) ? likeContainerRef : undefined}
                            className={`like-container${hasLikers ? ' sticky' : ''}${(hasLikers && likersAsTooltip) ? ' tooltip-trigger' : ''}`}
                            onClick={(!isArchived && likeCallback) ? likeCallback : undefined}
                        >
                            <Icon name={currentUserLikesComment ? "thumbs-up" : "thumbs-o-up"} />
                            {isMobile() ?
                                <label>
                                    {likersIdsLength} like{likersIdsLength !== 1 ? 's' : ''}
                                </label>
                                :
                                hasLikers ?
                                    (likersAsTooltip ?
                                        <React.Fragment>
                                            <span className="likers-count">
                                                {likersIdsLength}
                                            </span>
                                            <div className="tooltip">
                                                Liked by {likerListString}
                                            </div>
                                        </React.Fragment>
                                        :
                                        <div>
                                            <span>
                                                {likersIdsLength}
                                            </span>
                                            <span>
                                                {likerListString}
                                            </span>
                                        </div>
                                    )
                            : null }
                        </span>
                    : null }
                    { (!isArchived && reactCallback) ?
                        <span
                            ref={reactTriggerRef}
                            className={`react-trigger${isEmojiPopoverOpen ? ' active' : ''}`}
                            onClick={_ => setEmojiPopoverState(isEmojiPopoverOpen ? 'closing' : 'open')}
                        >
                            <Icon name="smile-o" />
                            { isMobile() ?
                                <label>
                                    React
                                </label>
                            : null }
                            { emojiPopoverState ?
                                <EmojiPopover
                                    anchorRef={reactTriggerRef}
                                    isOpen={isEmojiPopoverOpen}
                                    onSelect={emoji => {
                                        closeEmojiPopover()
                                        reactCallback(emoji)
                                    }}
                                    onClose={closeEmojiPopover}
                                    onExited={removeEmojiPopover}
                                />
                            : null }
                        </span>
                    : null }
                    { (canReply && replyCallback) ? 
                        <span onClick={replyCallback}>
                            <Icon name={'fe-corner-up-left'} />
                            { isMobile() ?
                                <label>
                                    Reply
                                </label>
                            : null}
                        </span>
                    : null}
                    {(canEdit && !isArchived && editCallback) ?
                        <span
                            onClick={editCallback}
                        >
                            <Icon name="fe-edit-2" />
                            {isMobile() ?
                                <label>
                                    Edit
                                </label>
                                : null}
                        </span>
                        : null
                    }
                    { (canEdit && deleteCallback) ?
                        <span onClick={deleteCallback}>
                            <Icon name="fe-trash-2" />
                            { isMobile() ?
                                <label>
                                    Delete
                                </label>
                            : null }
                        </span>
                    : null }
                </div>
                :
                <div>
                    <span onClick={saveCallback}>
                        <Icon name="check" />
                        { isMobile() ?
                            <label>
                                Save
                            </label>
                        : null }
                    </span>
                    <span onClick={cancelCallback}>
                        <Icon name="ban" />
                        { isMobile() ?
                            <label>
                                Cancel
                            </label>
                        : null }
                    </span>
                </div>
            }
        </div>
    )
};

export default ControlsLikeContainer;
